import {RadioButton} from "primereact/radiobutton";
import {Calendar} from "primereact/calendar";
import React, {useEffect, useState} from "react";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {setChangedScheduler, setCompanyField} from "redux/actions/actions";
import {Dropdown} from "primereact/dropdown";
import ScheduleTitle from "../ScheduleComponents/ScheduleTitle";
import TimeFromTo from "../ScheduleComponents/TimeFromTo";
import LaunchDate from "../ScheduleComponents/LaunchDate";
import moment from "moment";
import {classNames} from "primereact/utils";
import {MVP} from "../../../redux/config";
import CampaignDaysWeekSchedule from "../ScheduleComponents/CampaignDaysWeekSchedule";

const QueueListDialogStartEndFinish = (props: any) => {
    const dispatch = useAppDispatch()
    const companiesData = useAppSelector(state => state.CompaniesListReducer.companiesData);
    const archiveTableToggle = useAppSelector(state => state.CompaniesListReducer.archiveTableToggle);
    const schedulerType = useAppSelector(state => state.CompaniesListReducer.companiesDirectorySchedulerType);
    const errorFields = useAppSelector(state => state.CompaniesListReducer.errorFields);
    const [dates, setDates] = useState<any>(null);
    const statusDone = companiesData?.campaign?.statusId === 6;
    const editType = useAppSelector(state => state.UsersReducer.editType);

    moment.suppressDeprecationWarnings = true;

    const isValidDate = (value: any) => {
        const format = 'MM/DD/YYYY';
        return moment(value, format, true).isValid();
    };

    const handleDateChange = (date: any) => {
        return moment(date).format('MM/DD/YYYY HH:mm:ss');
    };

    const transformToDate = (dateString: any) => {
        return new Date(moment(dateString).format('MM/DD/YYYY HH:mm:ss'));
    }

    let startDateValue = new Date();
    startDateValue.setHours(0, 0, 0);

    let endDateValue = new Date();
    endDateValue.setHours(0, 0, 0);

    let startTimeValue = new Date();
    startTimeValue.setHours(0, 0, 0);

    let endTimeValue = new Date();
    endTimeValue.setHours(0, 0, 0);

    const [startTime] = useState<any>(startTimeValue);
    const [endTime] = useState<any>(endTimeValue);
    const [startDate] = useState<any>(startDateValue);
    const [endDate] = useState<any>(endDateValue);

    const scheduler = {
        startTime: (companiesData.scheduler && companiesData.scheduler.startTime) ? companiesData.scheduler.startTime : handleDateChange(startTime),
        endTime: (companiesData.scheduler && companiesData.scheduler.endTime) ? companiesData.scheduler.endTime : handleDateChange(endTime),
        startDate: (companiesData.scheduler && companiesData.scheduler.startDate) ? companiesData.scheduler.startDate : handleDateChange(startDate),
        endDate: (companiesData.scheduler && companiesData.scheduler.endDate) ? companiesData.scheduler.endDate : handleDateChange(endDate),
        typeScheduler: 401,
        typeEventStart: true,
        typeEventEnd: true,
        typeValue: 1,
    }

    const changeTypeScheduler = (e: any) => {
        dispatch(setCompanyField({section: 'scheduler', fieldName: 'typeScheduler', value: e.value}));
    };

    useEffect(() => {
        if ((!companiesData.scheduler || !companiesData.scheduler.schedulerId) && props.createdSchedule) {
            Object.entries(scheduler).map(([key, value]) => dispatch(setCompanyField({section: 'scheduler', fieldName: key, value: value})));
        }
    }, []);

    return (
        <div className="start-end-finish">
            <div className="grid p-fluid">
                <div className="field col-12 md:col-12">
                    <h6>Умови запуску</h6>

                    <div className="grid p-fluid">
                        {companiesData?.scheduler?.typeEventStart && <>
                            <div className="col-12 md:col-6">
                                <Dropdown className="field col-12 md:col-12" filter value={companiesData?.scheduler?.typeScheduler} onChange={(e) => {
                                    dispatch(setChangedScheduler(true));
                                    changeTypeScheduler(e)
                                }} options={schedulerType}
                                          disabled={!archiveTableToggle || statusDone || !editType}
                                          optionLabel="name"
                                          optionValue="dictionaryId"
                                          placeholder="Виберіть тип:"/>
                            </div>
                            <div className="col-12 md:col-12">
                                {companiesData?.scheduler?.typeScheduler === 401 && <>
                                    <div className="col-12 md:col-6">
                                        <ScheduleTitle/>
                                        <TimeFromTo archiveTableToggle={archiveTableToggle} startTime={scheduler.startTime} endTime={scheduler.endTime}/>
                                        <LaunchDate archiveTableToggle={archiveTableToggle} startDate={scheduler.startDate} companiesData={companiesData}/>
                                    </div>
                                </>}

                                {companiesData?.scheduler?.typeScheduler === 402 && <>
                                    <div className="col-12 md:col-6">
                                        <ScheduleTitle/>
                                        <TimeFromTo archiveTableToggle={archiveTableToggle} startTime={scheduler.startTime} endTime={scheduler.endTime}/></div>
                                </>}

                                {companiesData?.scheduler?.typeScheduler === 403 && <>
                                    <CampaignDaysWeekSchedule startDate={scheduler.startDate}/>
                                </>}

                                {companiesData?.scheduler?.typeScheduler === 404 && <div className="field col-12 md:col-6 m-0">
                                    <div className="field m-0">
                                        <label htmlFor="icon">Вибрані дні:</label>
                                    </div>
                                    <TimeFromTo archiveTableToggle={archiveTableToggle} startTime={scheduler.startTime} endTime={scheduler.endTime}/>
                                    <Calendar placeholder={'Виберіть дні'} className="pt-2" showIcon value={dates} onChange={(e) => setDates(e.value)} selectionMode="multiple" readOnlyInput/>
                                </div>}
                            </div>
                        </>}
                        {companiesData?.scheduler?.typeScheduler === 401 && <div className="field col-12 md:col-12 mt-3">
                            <h6>Умови завершення</h6>
                            <div className="grid p-fluid">
                                {!MVP && <div className="field col-12 md:col-4">
                                    <div className="field-radiobutton">
                                        <RadioButton
                                            inputId="finishingConditions1"
                                            name="finishingConditions"
                                            value={true}
                                            onChange={(e) => {
                                                dispatch(setChangedScheduler(true));
                                                dispatch(setCompanyField({section: 'scheduler', fieldName: 'typeEventEnd', value: e.value}))
                                            }}
                                            checked={companiesData?.scheduler?.typeEventEnd}
                                            disabled={!archiveTableToggle || statusDone}
                                        />
                                        <label htmlFor="finishingConditions1">За розкладом</label>
                                    </div>
                                </div>}
                                {!MVP && <div className="field col-12 md:col-4">
                                    <div className="field-radiobutton">
                                        <RadioButton
                                            inputId="launchFinishing2"
                                            name="launchFinishing"
                                            value={false}
                                            onChange={(e) => {
                                                dispatch(setChangedScheduler(true));
                                                dispatch(setCompanyField({section: 'scheduler', fieldName: 'typeEventEnd', value: e.value}))
                                            }}
                                            checked={!companiesData?.scheduler?.typeEventEnd}
                                            disabled={!archiveTableToggle || statusDone || MVP}
                                        />
                                        <label htmlFor="launchConditions2" className={classNames('', {'text-500': MVP})}>За подією</label>
                                    </div>
                                </div>}

                                {companiesData?.scheduler?.typeEventEnd && <>
                                    <div className="field col-12 md:col-6">
                                        <label htmlFor="icon">Дата завершення</label>
                                        <Calendar
                                            className={classNames('', {'p-invalid': errorFields?.endDate})}
                                            value={companiesData?.scheduler.endDate ? transformToDate(companiesData?.scheduler?.endDate) : transformToDate(scheduler.endDate)}
                                            onChange={(e: any) => {
                                                if (isValidDate(e.value)) {
                                                    dispatch(setChangedScheduler(true));
                                                    dispatch(setCompanyField({section: 'scheduler', fieldName: 'endDate', value: handleDateChange(e.value)}))
                                                }
                                            }}
                                            onInput={(e: any) => {
                                                const input = e.target as HTMLInputElement;

                                                const digits = input.value.replace(/\D/g, "").slice(0, 8); // ddMMyyyy

                                                const dd = digits.slice(0, 2);
                                                const mm = digits.slice(2, 4);
                                                const yyyy = digits.slice(4, 8);

                                                const display =
                                                    (dd || "") +
                                                    (digits.length > 2 ? "/" + mm : "") +
                                                    (digits.length > 4 ? "/" + yyyy : "");

                                                const newCaret =
                                                    digits.length +
                                                    (digits.length > 2 ? 1 : 0) +
                                                    (digits.length > 4 ? 1 : 0);

                                                if (input.value !== display) {
                                                    input.value = display;
                                                    input.setSelectionRange(newCaret, newCaret);
                                                }

                                                if (digits.length === 8) {
                                                    const day = parseInt(dd, 10);
                                                    const month = parseInt(mm, 10) - 1; // 0-based
                                                    const year = parseInt(yyyy, 10);
                                                    const parsed = new Date(year, month, day);

                                                    const valid =
                                                        !isNaN(parsed.getTime()) &&
                                                        parsed.getDate() === day &&
                                                        parsed.getMonth() === month &&
                                                        parsed.getFullYear() === year;

                                                    if (valid && isValidDate(parsed)) {
                                                        dispatch(setChangedScheduler(true));
                                                        dispatch(setCompanyField({section: 'scheduler', fieldName: 'endDate', value: handleDateChange(parsed)}));
                                                    }
                                                }
                                            }}
                                            onFocus={(e: any) => {
                                                e.target.value = "";
                                            }}
                                            onBlur={(e: any) => {
                                                const digits = e.target.value.replace(/\D/g, "");
                                                if (digits.length !== 8) {
                                                    e.target.value = "";
                                                    const originalValue = companiesData?.scheduler.endDate ? transformToDate(companiesData?.scheduler?.endDate) : transformToDate(scheduler.endDate);
                                                    if (originalValue) {
                                                        e.target.value = originalValue.toLocaleDateString('en-GB');
                                                    }
                                                }
                                            }}
                                            minDate={new Date()}
                                            maxDate={new Date(2030, 11, 31)}
                                            dateFormat="dd/mm/yy"
                                            placeholder="дд/мм/рр"
                                            disabled={!archiveTableToggle || statusDone || !editType}
                                        />
                                    </div>
                                </>}
                            </div>
                        </div>}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default QueueListDialogStartEndFinish
